import qs from 'qs';

import { useBuildRecognizeURL } from '@bonusly/url';

import { Route } from '../../../config/router';
import { pathWithId } from '../../../utils/api';
import { useHomepageRedesignEnabled } from '../components/BonusFeed/hooks/useHomepageRedesignEnabled';
import { cleanTag } from '../utils/hashtag';
import { FeedType } from './useFeedTypeOptions';

/**
 * Returns the appropriate URL for a hashtag link based on the homepage redesign check.
 *
 * When homepage redesign is enabled:
 *   - Returns a URL to the homepage with the hashtag as a filter and feedType=company
 *   - Example: /?feedType=company&hashtags[]=innovation
 *   - The feedType in URL is temporary navigation state (does not update user preference)
 *
 * When homepage redesign is disabled:
 *   - Returns the legacy monolith hashtag page URL
 *   - Example: /company/hashtags/innovation
 */
export const useHashtagLink = (hashtag: string) => {
	const isHomepageRedesignEnabled = useHomepageRedesignEnabled();
	const recognizeURL = useBuildRecognizeURL();

	if (isHomepageRedesignEnabled) {
		// Build URL with feedType and hashtag filter
		// feedType in URL triggers temporary feed switch without updating user preference
		const search = qs.stringify(
			{
				feedType: FeedType.Company,
				hashtags: [hashtag],
			},
			{
				addQueryPrefix: true,
				arrayFormat: 'brackets',
			}
		);
		return `/${search}`;
	}

	// Legacy: monolith route
	return recognizeURL(pathWithId(Route.Hashtags, cleanTag(hashtag)));
};
